import { useEffect, useState } from 'react';
import { getReviewerPhoto } from './workflow-api';

export default function ReviewerRequestPhoto({ submission, getAccessToken }) {
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  const removal = submission.requestType === 'PhotoRemoval';

  useEffect(() => {
    let active = true;
    let objectUrl = '';
    setUrl('');
    setError('');
    if (removal) return undefined;
    getReviewerPhoto(submission.id, getAccessToken).then(blob => {
      if (!active) return;
      objectUrl = URL.createObjectURL(blob);
      setUrl(objectUrl);
    }).catch(failure => {
      if (active) setError(failure.message || 'The submitted photo could not be loaded.');
    });
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [submission.id, removal, getAccessToken, attempt]);

  return <section className="reviewer-submitted-photo" aria-label="Submitted photo">
    <h4>Submitted photo</h4>
    {removal ? <p>No image is attached to this photo removal request.</p>
      : error ? <div role="status"><p>{error}</p><button onClick={() => setAttempt(value => value + 1)}>Retry photo</button></div>
        : url ? <figure><img src={url} alt={`Submitted profile photo for ${submission.employeeName}`} onError={() => setError('The submitted photo could not be displayed.')} /><figcaption>Image attached to this request—not the employee’s latest photo.</figcaption></figure>
          : <p role="status">Loading submitted photo…</p>}
  </section>;
}
